@if (isGrouped) {
  <div class="issue-popup grouped">
    <div class="popup-header-row">
      <div class="title">{{ groupCount }} {{ titlePlural }}</div>
      @if (date) {
        <div class="date-chip">
          <span class="date-chip-text">{{ date | date: 'MMM d' }}</span>
        </div>
      }
    </div>
    <div class="issue-list">
      @for (issue of issues; track issue.id) {
        <div class="issue-row" (click)="onSelectIssue(issue)">
          <div class="row-header">
            <div class="issue-title-sm">{{ titleFor(issue) || 'Issue' }}</div>
            <div
              class="chip"
              [style.background]="statusFor(issue).bg"
              [style.color]="statusFor(issue).fg">
              {{ statusFor(issue).label }}
            </div>
          </div>
          @if (typeFor(issue)) {
            <div class="issue-type-sm">{{ typeFor(issue) }}</div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <div class="issue-popup">
    <div class="popup-header-row">
      <div class="title">{{ titleSingular }}</div>
      @if (date) {
        <div class="date-chip">
          <span class="date-chip-text">{{ date | date: 'MMM d' }}</span>
        </div>
      }
    </div>

    @if (title) {
      <div class="issue-title">{{ title }}</div>
    }

    <div class="chips-row">
      <div
        class="chip"
        [style.background]="status.bg"
        [style.color]="status.fg">
        {{ status.label }}
      </div>
      @if (type) {
        <div class="chip type-chip">{{ type }}</div>
      }
    </div>

    @if (locationFromPhoto) {
      <div class="location-source" data-testid="issue-location-from-photo">
        <mat-icon>photo_camera</mat-icon>
        <span>Location from photo</span>
      </div>
    }

    @if (thumbs.length) {
      <div class="thumbs-row">
        @for (pic of thumbs; track pic.id) {
          <div class="thumb">
            <img [src]="pic.thumb_url || pic.original_url" alt="" />
          </div>
        }
      </div>
    }

    <div class="see-more" (click)="onSeeMore()">See more</div>
  </div>
}
